const PlaybookWaitingService = {
	/**
	 * When nobody can decide on or sign off a run: a short title saying so, and the server's
	 * reason, which names the real cause and its fix in the terms of the playbook's setting
	 * (the client profile names no manager, or nobody on the team holds the chosen role).
	 *
	 * @param {Object} params
	 * @param {Boolean} params.isSignoff whether the run waits on sign-off rather than decisions
	 * @param {String|null} params.whyNobody the server's reason
	 * @return {Object} { title, detail }
	 */
	describeUnassigned({ isSignoff, whyNobody }) {
		const title = isSignoff ? "No one can sign this run off" : "No one can decide on this run";
		return { title, detail: whyNobody || null };
	},

	/**
	 * Who a run that waits on people is with, for a list or a summary: "Waiting on Ana Lee to
	 * decide", or, when nobody can act, the nobody-can-act title and reason. Null when the run
	 * waits on nobody.
	 *
	 * @param {Object} params
	 * @param {Object} params.run a run from the results list, with review_stage and waitingOn
	 * @return {Object|null} { isUnassigned, title, detail }
	 */
	describeWaitingOn({ run }) {
		const { waitingOn } = run;
		if (!waitingOn) return null;
		const isSignoff = run.review_stage === "waiting_on_signoff";
		if (waitingOn.isUnassigned) return { isUnassigned: true, ...this.describeUnassigned({ isSignoff, whyNobody: waitingOn.whyNobody }) };
		const { people } = waitingOn;
		const names = people.length > 1 ? `${people.slice(0, -1).join(", ")} and ${people[people.length - 1]}` : people.join("");
		const title = `Waiting on ${names} to ${isSignoff ? "sign off" : "decide"}`;
		return { isUnassigned: false, title, detail: null };
	},
};

export default PlaybookWaitingService;
